const THEME_KEY = 'cinemania-theme';
const THEME_DARK = 'dark';
const THEME_LIGHT = 'light';

function applyTheme(theme) {
  const body = document.body;

  // always keep exactly one
  body.classList.remove('dark-theme', 'light-theme');

  if (theme === THEME_LIGHT) {
    body.classList.add('light-theme');
  } else {
    body.classList.add('dark-theme');
  }
}

function getSavedTheme() {
  const saved = localStorage.getItem(THEME_KEY);
  return saved === THEME_LIGHT ? THEME_LIGHT : THEME_DARK; // default dark
}

function saveTheme(theme) {
  localStorage.setItem(THEME_KEY, theme);
}

function initThemeToggle() {
  const toggleBtn = document.querySelector('.theme-toggle');
  if (!toggleBtn) return;

  // apply on load
  applyTheme(getSavedTheme());

  toggleBtn.addEventListener('click', () => {
    const current = document.body.classList.contains('light-theme') ? THEME_LIGHT : THEME_DARK;
    const next = current === THEME_LIGHT ? THEME_DARK : THEME_LIGHT;

    applyTheme(next);
    saveTheme(next);
  });
}

function initMobileMenu() {
  const menuTrigger = document.querySelector('.header-mobile-title');
  const menuOverlay = document.querySelector('[data-menu]');

  if (!menuTrigger || !menuOverlay) return;

  const openMenu = () => {
    menuOverlay.classList.remove('is-hidden');
    menuTrigger.setAttribute('aria-expanded', 'true');
  };
  const closeMenu = () => {
    menuOverlay.classList.add('is-hidden');
    menuTrigger.setAttribute('aria-expanded', 'false');
  };

  menuTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    // toggle
    if (menuOverlay.classList.contains('is-hidden')) openMenu();
    else closeMenu();
  });

  // close when clicking outside panel
  menuOverlay.addEventListener('click', (e) => {
    if (e.target === menuOverlay) closeMenu();
  });

  // close when clicking link
  menuOverlay.addEventListener('click', (e) => {
    const link = e.target.closest('.mobile-menu-link');
    if (link) closeMenu();
  });

  // close on Esc
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });
}

function initActiveNav() {
  const path = window.location.pathname;
  const current = path.split('/').pop() || 'index.html';

  const links = document.querySelectorAll(
    '.header-nav-link, .mobile-menu-link'
  );
  if (!links.length) return;

  links.forEach(link => link.classList.remove('active'));

  links.forEach(link => {
    const href = link.getAttribute('href');
    if (!href) return;
    const hrefFile = href.split('/').pop();
    if (hrefFile === current) link.classList.add('active');
  });
}

export function initHeader() {
  initThemeToggle();
  initMobileMenu();
  initActiveNav();
}
